var map = {
	"./bat.svg": 20839,
	"./bee.svg": 20466,
	"./butterfly.svg": 61543,
	"./camel.svg": 5512,
	"./dolphin.svg": 56246,
	"./dragon.svg": 17655,
	"./duck.svg": 23553,
	"./elephant.svg": 8105,
	"./fish.svg": 97884,
	"./flamingo.svg": 88305,
	"./giraffe.svg": 42670,
	"./hedgehog.svg": 45625,
	"./kangaroo.svg": 48936,
	"./monkey.svg": 82605,
	"./octopus.svg": 77,
	"./owl.svg": 97548,
	"./parrot.svg": 99986,
	"./penguin.svg": 41374,
	"./rabbit.svg": 58946,
	"./rhinoceros.svg": 6172,
	"./scorpion.svg": 59081,
	"./sea_turtle.svg": 82976,
	"./sheep.svg": 51299,
	"./squirrel.svg": 999,
	"./tiger.svg": 8839,
	"./whale.svg": 99829
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19267;